<template>
  <v-dialog
    v-model="showModalPayments"
    width="480px"
    persistent
    lazy
    scrollable
  >
    <v-card>
      <v-form
        ref="form"
        v-model="validForm"
        @submit.prevent="submitPayments"
      >
        <v-container>
          <v-flex
            xs12
            md12
          >
            <v-toolbar
              color="green darken-3"
              dark
            >
              <v-toolbar-title>AGREGAR PAGO</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-layout column>
            <v-radio-group
              v-model="payment_method"
              row
            >
              <template v-slot:label>
                <div><strong>Metodo de Pago</strong></div>
              </template>
              <v-radio
                value="Voucher"
              >
                <template v-slot:label>
                  <div>Por <strong class="success--text">Voucher</strong></div>
                </template>
              </v-radio>
              <v-radio value="Boleta de venta">
                <template v-slot:label>
                  <div>Por <strong class="primary--text">Recibo de Caja</strong></div>
                </template>
              </v-radio>
            </v-radio-group>
            <v-flex
              sm12
              xs12
            >
              <v-text-field
                v-if="payment_method === 'Voucher'"
                v-model="form.code_voucher"
                label="NUMERO VOUCHER"
                :rules="rules.code_voucher"
                :counter="7"
                maxlength="7"
              />
              <v-text-field
                v-if="payment_method === 'Boleta de venta'"
                v-model="form.code_bill"
                label="RECIBO DE CAJA"
                :rules="rules.code_bill"
                :counter="6"
                maxlength="6"
              />
            </v-flex>
            <v-text-field
              v-model="form.amount_paid"
              label="CANTIDAD DE PAGO O PRECIO"
              :rules="rules.amount_paid"
              prefix="S/."
            />
          </v-layout>
          <v-btn
            @click="replaceShowModalPayments({ status: false })"
          >
            Cancelar
          </v-btn>
          <v-btn
            type="submit"
            color="success"
            :disabled="!validForm || processingForm"
            :loading="processingForm"
          >
            Guardar
          </v-btn>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      payment_method: 'Voucher',
      form: {
        amount_paid: 0,
        code_bill: '',
        code_voucher: ''
      },
      validForm: true,
      processingForm: false,
      rules: {
        code_voucher: [
          v => !!v || 'El voucher es requerido.',
          v => /^[0-9]{7}$/.test(v) || 'Ingresar solo numeros y 7 digitos.'
        ],
        code_bill: [
          v => !!v || 'El número de la boleta de venta es requerido.',
          v => /^[0-9]{6}$/.test(v) || 'Ingresar solo numeros y 6 digitos.'
        ],
        amount_paid: [
          v => !!v || 'El precio es requerido'
        ]
      }
    }
  },
  computed: {
    ...mapState({
      showModalPayments: state => state.cepre.showModalPayments,
      currentRegistered: state => state.register.currentRegistered
    })
  },
  watch: {
    showModalPayments (newValue, oldValue) {
      if (!newValue) {
        this.replaceCurrentRegistered({ register: null })
        return false
      }
    }
  },
  methods: {
    ...mapActions({
      replaceShowModalPayments: 'cepre/replaceShowModalPayments',
      replaceCurrentRegistered: 'register/replaceCurrentRegistered',
      payments: 'cepre/payments'
    }),
    submitPayments () {
      this.processingForm = true
      this.payments({
        Id: this.currentRegistered.id,
        data: this.form
      })
        .then(response => {
          this.processingForm = false
          this.replaceShowModalPayments({ status: false })
          this.$router.push({ name: 'inscritoscepre' })
        })
        .catch((error) => {
          this.processingForm = false
          this.formErrors = error.response.data.errors || {}
        })
    }
  }
}
</script>
